<script>
  import { _ } from "svelte-i18n";
  import { v4 as uuidv4 } from "uuid";
  import { Link } from "svelte-routing";
  import { useQueryClient } from "@sveltestack/svelte-query";
  import request from "superagent";

  import Technique from "./figureSkating/Technique.svelte";
  import Mobility from "./figureSkating/Mobility.svelte";
  import Mental from "./figureSkating/Mental.svelte";
  import Endurance from "./general/endurance/EnduranceForm.svelte";
  import StrengthTraining from "./general/StrengthTraining.svelte";
  import Radio from "./Radio.svelte";
  import ViewSession from "./ViewSession.svelte";

  export let active = false;
  export let date = new Date();
  export let sessions = [];

  let name;
  let description = "";
  let experiencedLoad = undefined;
  let condition = undefined;
  let typeOfTraining = undefined;
  let olympicTraining = undefined;
  let warmUp = [];
  let elements = [];
  let conclusion = [];
  let comments = "";
  let drinkDuringTraining = false;
  let energiConsumptionDuringTraining = false;
  let energiConsumptionAfterTraining = false;
  let restSleep = false;
  let massage = false;
  let activeSession;

  $: loggedSessionsOnDate = uniqueSessions(sessions).filter(
    (session) => session.date === date.toISOString().slice(0, 10)
  );

  const queryClient = useQueryClient();

  function uniqueSessions(sessions) {
    return [
      ...new Set((sessions ? sessions : []).map((item) => item?.reference)),
    ]
      .map((entry) =>
        sessions
          .slice()
          .reverse()
          .find((item) => item?.reference === entry)
      )
      .filter((item) => item);
  }

  function clearContent() {
    name = undefined;
    description = "";
    experiencedLoad = undefined;
    condition = undefined;
    typeOfTraining = undefined;
    olympicTraining = undefined;
    warmUp = [];
    elements = [];
    conclusion = [];
    comments = "";
    drinkDuringTraining = false;
    energiConsumptionDuringTraining = false;
    energiConsumptionAfterTraining = false;
    restSleep = false;
    massage = false;
  }

  function close() {
    removeDeleted();
    activeSession = undefined;
    clearContent();
    active = false;
    window.document.body.classList.toggle("modal-is-active");
  }

  function saveToServer(userContent, session) {
    const user = userContent !== null ? JSON.parse(userContent).id : undefined;
    if (user !== undefined) {
      console.log("Save session for user ", user);
      request
        .post("/api/sessions")
        .set("Content-Type", "application/json")
        .set("Authorization", "Bearer " + user)
        .send(session)
        .then((response) => {
          console.log("[INFO] Saved to server");
          let storedInLocalStorage = localStorage.getItem("sessions");
          let parsedContent =
            storedInLocalStorage !== null
              ? JSON.parse(storedInLocalStorage)
              : [];
          sessions = localStorage.setItem(
            "sessions",
            JSON.stringify(
              parsedContent.map((item) =>
                item.reference === response.body.reference &&
                item.id === response.body.id
                  ? { ...item, version: response.body.version }
                  : item
              )
            )
          );
          queryClient.invalidateQueries("sessions");
        })
        .catch((error) =>
          console.log("[ERROR] Not able to save to server, got", error)
        );
    }
  }

  function save() {
    removeDeleted();
    let storedSessions = localStorage.getItem("sessions");
    sessions = storedSessions !== null ? JSON.parse(storedSessions) : [];
    const session = {
      id: uuidv4(),
      reference: uuidv4(),
      name: name,
      description: description,
      date: date.toISOString().slice(0, 10),
      warmUp: warmUp,
      main: elements,
      conclusion: conclusion,
      experiencedLoad: experiencedLoad,
      condition: condition,
      olympicTraining: olympicTraining,
      comments: comments,
      typeOfTraining: typeOfTraining,
      restitution: {
        drinkDuringTraining: drinkDuringTraining,
        energiConsumptionDuringTraining: energiConsumptionDuringTraining,
        energiConsumptionAfterTraining: energiConsumptionAfterTraining,
        restSleep: restSleep,
        massasje: massage,
      },
    };
    sessions = sessions.concat(session);
    localStorage.setItem("sessions", JSON.stringify(sessions));
    saveToServer(localStorage.getItem("user"), session);
    close();
    //    location.reload();
    return false;
  }

  function addElement(type, position) {
    switch (position) {
      case "main":
        elements = elements.concat({ type: type });
        break;
      case "warmUp":
        warmUp = warmUp.concat({ type: type });
        break;
      default:
        conclusion = conclusion.concat({ type: type });
    }
  }

  let showDetails = true;
  function toggle() {
    showDetails = !showDetails;
  }

  let showOppvarming = false;
  function toggleOppvarming() {
    showOppvarming = !showOppvarming;
  }

  let showAvsluttning = false;
  function toggleAvsluttning() {
    showAvsluttning = !showAvsluttning;
  }

  let showExpirience = true;
  function toggleExpirience() {
    showExpirience = !showExpirience;
  }

  let showRestituon = false;
  function toggleRestituon() {
    showRestituon = !showRestituon;
  }

  let showForm = true;
  function toggleForm() {
    showForm = !showForm;
  }

  let showOlympicTraining = false;
  function toggleOlympicTraining() {
    showOlympicTraining = !showOlympicTraining;
  }

  function removeDeleted() {
    for (let i = 0; i < elements.length; i++) {
      if (
        elements[i].repetitions == "removed" ||
        elements[i].duration == "removed"
      ) {
        elements.splice(i, 1);
        i = i - 1;
      }
    }

    for (let i = 0; i < warmUp.length; i++) {
      if (
        warmUp[i].repetitions == "removed" ||
        warmUp[i].duration == "removed"
      ) {
        warmUp.splice(i, 1);
        i = i - 1;
      }
    }

    for (let i = 0; i < conclusion.length; i++) {
      if (
        conclusion[i].repetitions == "removed" ||
        conclusion[i].duration == "removed"
      ) {
        conclusion.splice(i, 1);
        i = i - 1;
      }
    }
  }
</script>

{#if active}
  <div class="modal">
    <div class="modal__backdrop" />
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: 0s ease 0s 1 normal none running none;"
      >
        <div class="day">
          <header class="modal__header modal__header--day padded_modal_header">
            <div
              class="layout-buttons layout-buttons--vertical-center layout-buttons--underlined-invert"
            >
              <div
                class="layout-buttons-inner layout-buttons-inner--fill layout-buttons-inner--vertical-center"
              >
                <button class="modal__heading" type="button">
                  <span class="h2 day__date day__date--display_short_if_sm"
                    >{date.toLocaleString("no", {
                      weekday: "long",
                      day: "numeric",
                      month: "short",
                    })}</span
                  >
                  <span
                    class="h2 day__date day__date--display_shortest_if_not_sm"
                    >{date.toLocaleString("no", {
                      weekday: "short",
                      day: "numeric",
                      month: "short",
                    })}</span
                  >
                </button>
                <span class="layout-buttons-inner__spacer" />
                <button
                  on:click={() => {
                    activeSession = undefined;
                    date = new Date(date.getTime() - 24 * 60 * 60 * 1000);
                  }}
                  type="button"
                  class="day__button-previous"
                />
                <button
                  on:click={() => {
                    activeSession = undefined;
                    date = new Date(date.getTime() + 24 * 60 * 60 * 1000);
                  }}
                  type="button"
                  class="day__button-next"
                />
                <button
                  on:click={close}
                  type="button"
                  class="modal__button-close"
                />
              </div>
            </div>
            <button
              type="button"
              class="day__button-status-toggle day__button-status-toggle--ok"
              >{$_("sessions.dayParameters")}</button
            >
            <div class="day-status">
              <div>
                <div
                  class="health-status-checkbox-group health-status-checkbox-group--status"
                >
                  <label
                    class="health-status-checkbox health-status-checkbox--status-ill"
                    for="status-ill"
                    ><input
                      type="checkbox"
                      class="health-status-checkbox__input-hidden"
                      name="status"
                      title="Syk"
                      id="status-ill"
                      value="status-ill"
                    /><span
                      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-ill"
                    /><span class="health-status-checkbox__label">Syk</span
                    ></label
                  ><label
                    class="health-status-checkbox health-status-checkbox--status-injured"
                    for="status-injured"
                    ><input
                      type="checkbox"
                      class="health-status-checkbox__input-hidden"
                      name="status"
                      title="Skadet"
                      id="status-injured"
                      value="status-injured"
                    /><span
                      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-injured"
                    /><span class="health-status-checkbox__label">Skadet</span
                    ></label
                  ><label
                    class="health-status-checkbox health-status-checkbox--status-travelDay"
                    for="status-travelDay"
                    ><input
                      type="checkbox"
                      class="health-status-checkbox__input-hidden"
                      name="status"
                      title="På reise"
                      id="status-travelDay"
                      value="status-travelDay"
                    /><span
                      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-travelDay"
                    /><span class="health-status-checkbox__label">På reise</span
                    ></label
                  ><label
                    class="health-status-checkbox health-status-checkbox--status-height"
                    for="status-height"
                    ><input
                      type="checkbox"
                      class="health-status-checkbox__input-hidden"
                      name="status"
                      title="Høydedøgn"
                      id="status-height"
                      value="status-height"
                    /><span
                      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-height"
                    /><span class="health-status-checkbox__label"
                      >Høydedøgn</span
                    ></label
                  ><label
                    class="health-status-checkbox health-status-checkbox--status-dayOff"
                    for="status-dayOff"
                    ><input
                      type="checkbox"
                      class="health-status-checkbox__input-hidden"
                      name="status"
                      title="Fridag"
                      id="status-dayOff"
                      value="status-dayOff"
                    /><span
                      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-dayOff"
                    /><span class="health-status-checkbox__label">Fridag</span
                    ></label
                  ><label
                    class="health-status-checkbox health-status-checkbox--status-competitionDay"
                    for="status-competitionDay"
                    ><input
                      type="checkbox"
                      class="health-status-checkbox__input-hidden"
                      name="status"
                      title="Konkurranse"
                      id="status-competitionDay"
                      value="status-competitionDay"
                    /><span
                      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-competitionDay"
                    /><span class="health-status-checkbox__label"
                      >Konkurranse</span
                    ></label
                  >
                </div>
                <label for=""
                  ><span class="input__label">Hvilepuls</span><span
                    class="input__item input__item--inverted"
                    ><input
                      type="numeric"
                      class="input__number"
                      data-label=""
                      data-id=""
                      name="Hvilepuls"
                      id="Hvilepuls"
                      autocomplete="off"
                      value=""
                    />
                    <p class="input__error input__error--inverted" />
                  </span></label
                >
                <div class="form-section form-section--paddingless">
                  <h3>
                    <button
                      type="button"
                      class="button-text button-text--chevron-down button-text--white button-text--chevron-down-white"
                      >Søvn</button
                    >
                  </h3>
                  <div class="radio-group--default-hide">
                    <h4 class="invertedText">Søvnkvalitet</h4>
                    <div>
                      <div class="radio-group__labels false">
                        <span
                          class="radio-group__label radio-group__label--left radio-group__label--inverted"
                          >Lav søvnkvalitet</span
                        ><span class="radio-group__label" /><span
                          class="radio-group__label radio-group__label--right radio-group__label--inverted"
                          >Høy søvnkvalitet</span
                        >
                      </div>
                      <div
                        class="radio-group radio-group--1-10 radio-group--inverted"
                      >
                        <label class="radio" for="radio-1-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="1"
                          /><span
                            class="radio__input-custom radio__input-custom--1 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >1</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--1 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-2-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="2"
                          /><span
                            class="radio__input-custom radio__input-custom--2 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >2</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--2 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-3-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="3"
                          /><span
                            class="radio__input-custom radio__input-custom--3 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >3</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--3 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-4-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="4"
                          /><span
                            class="radio__input-custom radio__input-custom--4 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >4</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--4 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-5-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="5"
                          /><span
                            class="radio__input-custom radio__input-custom--5 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >5</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--5 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-6-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="6"
                          /><span
                            class="radio__input-custom radio__input-custom--6 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >6</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--6 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-7-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="7"
                          /><span
                            class="radio__input-custom radio__input-custom--7 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >7</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--7 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-8-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="8"
                          /><span
                            class="radio__input-custom radio__input-custom--8 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >8</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--8 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-9-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="9"
                          /><span
                            class="radio__input-custom radio__input-custom--9 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >9</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--9 radio__1-10-line--inverted"
                          /></label
                        ><label class="radio" for="radio-10-Søvnkvalitet"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="10"
                          /><span
                            class="radio__input-custom radio__input-custom--10 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >10</span
                          ></label
                        >
                      </div>
                    </div>
                    <label for=""
                      ><span class="input__label"
                        >Søvnlengde (timer:minutter)</span
                      ><span class="input__item input__item--inverted"
                        ><input
                          type="text"
                          class="input__number"
                          data-label=""
                          data-id=""
                          name="sleepNight"
                          id=""
                          autocomplete="off"
                          value=""
                        />
                        <p class="input__error input__error--inverted" />
                      </span></label
                    >
                  </div>
                </div>
                <div class="form-section form-section--paddingless">
                  <h3>
                    <button
                      type="button"
                      class="button-text button-text--chevron-down button-text--white button-text--chevron-down-white"
                      >Readiness to train</button
                    >
                  </h3>
                  <div class="radio-group--default-hide">
                    <h4 class="invertedText">
                      Hvor fysisk klar er du for å trene / konkurrere?
                    </h4>
                    <div>
                      <div class="radio-group__labels false">
                        <span
                          class="radio-group__label radio-group__label--left radio-group__label--inverted"
                          >Ikke klar</span
                        ><span class="radio-group__label" /><span
                          class="radio-group__label radio-group__label--right radio-group__label--inverted"
                          >Svært klar</span
                        >
                      </div>
                      <div
                        class="radio-group radio-group--1-10 radio-group--inverted"
                      >
                        <label
                          class="radio"
                          for="radio-1-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="1"
                          /><span
                            class="radio__input-custom radio__input-custom--1 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >1</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--1 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-2-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="2"
                          /><span
                            class="radio__input-custom radio__input-custom--2 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >2</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--2 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-3-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="3"
                          /><span
                            class="radio__input-custom radio__input-custom--3 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >3</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--3 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-4-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="4"
                          /><span
                            class="radio__input-custom radio__input-custom--4 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >4</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--4 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-5-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="5"
                          /><span
                            class="radio__input-custom radio__input-custom--5 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >5</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--5 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-6-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="6"
                          /><span
                            class="radio__input-custom radio__input-custom--6 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >6</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--6 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-7-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="7"
                          /><span
                            class="radio__input-custom radio__input-custom--7 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >7</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--7 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-8-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="8"
                          /><span
                            class="radio__input-custom radio__input-custom--8 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >8</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--8 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-9-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="9"
                          /><span
                            class="radio__input-custom radio__input-custom--9 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >9</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--9 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-10-Hvor fysisk klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="10"
                          /><span
                            class="radio__input-custom radio__input-custom--10 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >10</span
                          ></label
                        >
                      </div>
                    </div>
                    <h4 class="invertedText">
                      Hvor mentalt klar er du for å trene / konkurrere?
                    </h4>
                    <div>
                      <div class="radio-group__labels false">
                        <span
                          class="radio-group__label radio-group__label--left radio-group__label--inverted"
                          >Ikke klar</span
                        ><span class="radio-group__label" /><span
                          class="radio-group__label radio-group__label--right radio-group__label--inverted"
                          >Svært klar</span
                        >
                      </div>
                      <div
                        class="radio-group radio-group--1-10 radio-group--inverted"
                      >
                        <label
                          class="radio"
                          for="radio-1-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="1"
                          /><span
                            class="radio__input-custom radio__input-custom--1 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >1</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--1 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-2-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="2"
                          /><span
                            class="radio__input-custom radio__input-custom--2 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >2</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--2 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-3-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="3"
                          /><span
                            class="radio__input-custom radio__input-custom--3 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >3</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--3 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-4-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="4"
                          /><span
                            class="radio__input-custom radio__input-custom--4 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >4</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--4 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-5-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="5"
                          /><span
                            class="radio__input-custom radio__input-custom--5 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >5</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--5 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-6-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="6"
                          /><span
                            class="radio__input-custom radio__input-custom--6 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >6</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--6 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-7-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="7"
                          /><span
                            class="radio__input-custom radio__input-custom--7 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >7</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--7 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-8-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="8"
                          /><span
                            class="radio__input-custom radio__input-custom--8 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >8</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--8 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-9-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="9"
                          /><span
                            class="radio__input-custom radio__input-custom--9 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >9</span
                          ><span
                            class="radio__1-10-line radio__1-10-line--9 radio__1-10-line--inverted"
                          /></label
                        ><label
                          class="radio"
                          for="radio-10-Hvor mentalt klar er du for å trene / konkurrere?"
                          ><input
                            type="radio"
                            class="radio__input-hidden"
                            value="10"
                          /><span
                            class="radio__input-custom radio__input-custom--10 radio__input-custom--inverted"
                          /><span class="radio__label radio__label--inverted"
                            >10</span
                          ></label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-section form-section--paddingless">
                  <h3>
                    <button
                      type="button"
                      class="button-text button-text--chevron-down is-toggled button-text--white button-text--chevron-down-white"
                      >Kommentar til dagen</button
                    >
                  </h3>
                  <div class="">
                    <fieldset>
                      <label class="input" for="comment-activity"
                        ><textarea
                          rows="5"
                          type="text"
                          inputmode="text"
                          name="comment-activity"
                          id="comment-activity"
                          class="input__text"
                        /></label
                      >
                    </fieldset>
                  </div>
                </div>
                <button type="button" class="button button--disabled"
                  >Lagre</button
                >
              </div>
            </div>
            <h3 class="day__purpose">Logg utført økt</h3>
            <nav class="nav-activities">
              <ul class="nav-activities__tabs">
                {#each loggedSessionsOnDate as session, index}
                  <li class="nav-activities__tab">
                    <Link
                      to="/"
                      on:click={() => {
                        activeSession = index;
                      }}
                    >
                      <a
                        class="nav-activities__button-tab is-done {activeSession ===
                        index
                          ? 'is-active'
                          : ''}"
                        aria-current="false"
                        href="/">{$_("sessions.session")} {index + 1}</a
                      >
                    </Link>
                  </li>
                {/each}
                {#if activeSession !== undefined}
                  <li class="nav-activities__tab nav-activities__tab--reduce">
                    <Link to="/" on:click={() => (activeSession = undefined)}>
                      <a
                        role="link"
                        tabindex="0"
                        class=" nav-activities__button-tab nav-activities__button-tab--add-tab no-margin-bottom"
                        type="button"
                        style="cursor: pointer;">{$_("sessions.add")}</a
                      >
                    </Link>
                  </li>
                {:else}
                  <li class="nav-activities__tab">
                    <div
                      class=" nav-activities__button-tab is-draft {activeSession ===
                      undefined
                        ? 'is-active'
                        : ''}"
                    >
                      {$_("sessions.session")}
                      {uniqueSessions(sessions).filter(
                        (session) =>
                          session.date === date.toISOString().slice(0, 10)
                      ).length + 1}
                    </div>
                  </li>
                  <button
                    class=" nav-activities__button-tab nav-activities__button-tab--add-tab no-margin-bottom is-disabled"
                    disabled="">{$_("sessions.add")}</button
                  >
                {/if}
              </ul>
            </nav>
          </header>
          <div class="modal__body" />
          {#if activeSession !== undefined}
            <ViewSession session={loggedSessionsOnDate[activeSession]} />
          {:else}
            <div class="modal__body">
              <form>
                <fieldset class="form-section">
                  <label class="input" for="name"
                    ><span class="input__label">{$_("sessions.form.name")}</span
                    ><input
                      type="text"
                      class="input__text"
                      name="Navn"
                      id="title"
                      bind:value={name}
                    /></label
                  >
                  <label class="input" for="description"
                    ><span class="input__label"
                      >{$_("sessions.form.description")}</span
                    ><textarea
                      rows="3"
                      class="input__text"
                      name="description"
                      id="description"
                      bind:value={description}
                    /></label
                  >
                </fieldset>
                <div>
                  <fieldset style="display:none" class="form-section">
                    <span class="select__label">Type trening</span>
                    <div class="radio-group radio-group--wrap">
                      <label
                        class="radio"
                        for="type-activity--GymnasticsWomen.TrainingTypeClubActivity"
                        ><input
                          type="radio"
                          class="radio__input-hidden"
                          bind:group={typeOfTraining}
                          value="GymnasticsWomen.TrainingTypeClubActivity"
                        /><span class="radio__input-custom" /><span
                          class="radio__label">Klubbaktivitet</span
                        ></label
                      ><label
                        class="radio"
                        for="type-activity--GymnasticsWomen.TrainingTypeIndividual"
                        ><input
                          type="radio"
                          bind:group={typeOfTraining}
                          class="radio__input-hidden"
                          value="GymnasticsWomen.TrainingTypeIndividual"
                        /><span class="radio__input-custom" /><span
                          class="radio__label">Individuell trening</span
                        ></label
                      ><label
                        class="radio"
                        for="type-activity--GymnasticsWomen.TrainingTypeRegional"
                        ><input
                          type="radio"
                          bind:group={typeOfTraining}
                          class="radio__input-hidden"
                          value="GymnasticsWomen.TrainingTypeRegional"
                        /><span class="radio__input-custom" /><span
                          class="radio__label">Regionalt/Olympiatoppen</span
                        ></label
                      ><label
                        class="radio"
                        for="type-activity--GymnasticsWomen.TrainingTypeNational"
                        ><input
                          type="radio"
                          bind:group={typeOfTraining}
                          class="radio__input-hidden"
                          value="GymnasticsWomen.TrainingTypeNational"
                        /><span class="radio__input-custom" /><span
                          class="radio__label">Landslagssamling</span
                        ></label
                      >
                    </div>
                  </fieldset>
                  <fieldset class="form-section">
                    <h3>
                      <button
                        on:click={toggleOppvarming}
                        type="button"
                        class="button-text button-text--chevron-down {showOppvarming
                          ? 'is-toggled'
                          : ''}">{$_("sessions.form.warmup")}</button
                      >
                    </h3>
                    <div
                      class={showOppvarming ? "" : "radio-group--default-hide"}
                    >
                      <div class="form-subsection-wrapper">
                        {#each warmUp as element}
                          {#if element.type === "mobility"}
                            <Mobility bind:duration={element.duration} />
                          {:else if element.type === "endurance"}
                            <Endurance
                              bind:duration={element.duration}
                              bind:activity={element.activity}
                              bind:metrics={element.metrics}
                            />
                          {/if}
                        {/each}
                        {#if false}
                          <div
                            class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                          >
                            <button
                              type="button"
                              class="button-text button-text--add"
                              >Legg til teknikktrening</button
                            >
                          </div>
                        {/if}
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("mobility", "warmUp")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.mobility.add")}</button
                          >
                        </div>
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("endurance", "warmUp")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.endurance.add")}</button
                          >
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="form-section">
                    <h3>
                      <button
                        on:click={toggle}
                        type="button"
                        class="button-text button-text--chevron-down {showDetails
                          ? 'is-toggled'
                          : ''}">{$_("sessions.form.main")}</button
                      >
                    </h3>
                    <div class={showDetails ? "" : "radio-group--default-hide"}>
                      <div class="form-subsection-wrapper">
                        {#each elements as element}
                          {#if element.type === "technique"}
                            <Technique
                              bind:duration={element.duration}
                              bind:element={element.element}
                              bind:level={element.level}
                              bind:repetitions={element.repetitions}
                              bind:successful={element.successful}
                              bind:content={element.content}
                            />
                          {:else if element.type === "mobility"}
                            <Mobility bind:duration={element.duration} />
                          {:else if element.type === "mental"}
                            <Mental bind:duration={element.duration} />
                          {:else if element.type === "endurance"}
                            <Endurance
                              bind:duration={element.duration}
                              bind:activity={element.activity}
                              bind:metrics={element.metrics}
                            />
                          {:else if element.type === "strength"}
                            <StrengthTraining
                              bind:duration={element.duration}
                              bind:method={element.method}
                              bind:focus={element.focus}
                            />
                          {/if}
                        {/each}
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("technique", "main")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.iceTraining.add")}</button
                          >
                        </div>
                        {#if false}
                          <div
                            class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                          >
                            <button
                              type="button"
                              class="button-text button-text--add"
                              >Legg til teknikktrening</button
                            >
                          </div>
                          <div
                            class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                          >
                            <button
                              type="button"
                              class="button-text button-text--add"
                              >Legg til utholdenhet</button
                            >
                          </div>
                          <div
                            class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                          >
                            <button
                              type="button"
                              class="button-text button-text--add"
                              >Legg til styrke, hurtighet og spenst</button
                            >
                          </div>
                        {/if}
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("mobility", "main")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.mobility.add")}</button
                          >
                        </div>
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("endurance", "main")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.endurance.add")}</button
                          >
                        </div>
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("strength", "main")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.strength.add")}</button
                          >
                        </div>
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("mental", "main")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.mental.add")}</button
                          >
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="form-section">
                    <h3>
                      <button
                        on:click={toggleAvsluttning}
                        type="button"
                        class="button-text button-text--chevron-down {showAvsluttning
                          ? 'is-toggled'
                          : ''}">{$_("sessions.form.ending")}</button
                      >
                    </h3>
                    <div
                      class={showAvsluttning ? "" : "radio-group--default-hide"}
                    >
                      <div class="form-subsection-wrapper">
                        {#each conclusion as element}
                          {#if element.type === "mobility"}
                            <Mobility bind:duration={element.duration} />
                          {:else if element.type === "mental"}
                            <Mental bind:duration={element.duration} />
                          {/if}
                        {/each}
                        {#if false}
                          <div
                            class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                          >
                            <button
                              type="button"
                              class="button-text button-text--add"
                              >Legg til teknikktrening</button
                            >
                          </div>
                        {/if}
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() =>
                              addElement("mobility", "conclusion")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.mobility.add")}</button
                          >
                        </div>
                        <div
                          class="layout-buttons layout-buttons--centered layout-buttons--no-margin-bottom"
                        >
                          <button
                            on:click={() => addElement("mental", "conclusion")}
                            type="button"
                            class="button-text button-text--add"
                            >{$_("sessions.form.mental.add")}</button
                          >
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="form-section form-section--emphasis">
                    <h3>{$_("sessions.form.totalTime")}</h3>
                    <p />
                  </fieldset>
                  <div class="radio_scale">
                    <div
                      class="form-section"
                      id="GymnasticsWomen.PerceivedExertion"
                    >
                      <h3>
                        <button
                          on:click={toggleExpirience}
                          type="button"
                          class="button-text button-text--chevron-down {showExpirience
                            ? 'is-toggled'
                            : ''}"
                          >{$_("sessions.form.experiencedLoad.title")}</button
                        >
                      </h3>
                      <div
                        class={showExpirience
                          ? ""
                          : "radio-group--default-hide"}
                      >
                        <div class="radio-group__labels">
                          <span
                            class="radio-group__label radio-group__label--left"
                            >{$_("sessions.form.experiencedLoad.low")}</span
                          ><span class="radio-group__label" /><span
                            class="radio-group__label radio-group__label--right"
                            >{$_("sessions.form.experiencedLoad.high")}</span
                          >
                        </div>
                        <div class="radio-group radio-group--1-10">
                          {#each { length: 10 } as _, index}
                            <Radio
                              bind:group={experiencedLoad}
                              value={index + 1}
                              label="Belastning"
                            />
                          {/each}
                        </div>
                      </div>
                    </div>
                    <div class="form-section" id="GymnasticsWomen.FormN">
                      <h3>
                        <button
                          on:click={toggleForm}
                          type="button"
                          class="button-text button-text--chevron-down {showForm
                            ? 'is-toggled'
                            : ''}">{$_("sessions.form.formN.title")}</button
                        >
                      </h3>
                      <div class={showForm ? "" : "radio-group--default-hide"}>
                        <div class="radio-group__labels">
                          <span
                            class="radio-group__label radio-group__label--left"
                            >{$_("sessions.form.formN.low")}</span
                          ><span class="radio-group__label" /><span
                            class="radio-group__label radio-group__label--right"
                            >{$_("sessions.form.formN.high")}</span
                          >
                        </div>
                        <div class="radio-group radio-group--1-10">
                          {#each { length: 10 } as _, index}
                            <Radio
                              bind:group={condition}
                              value={index + 1}
                              label="Dagsform"
                            />
                          {/each}
                        </div>
                      </div>
                    </div>
                    {#if false}
                      <div
                        class="form-section"
                        id="GymnasticsWomen.OlympicTraining"
                      >
                        <h3>
                          <button
                            on:click={toggleOlympicTraining}
                            type="button"
                            class="button-text button-text--chevron-down {showOlympicTraining
                              ? 'is-toggled'
                              : ''}"
                            >OLYMPISK TRENING - GJENNOMFØRING ETTER PLAN OG MÅL</button
                          >
                        </h3>
                        <div
                          class={showOlympicTraining
                            ? ""
                            : "radio-group--default-hide"}
                        >
                          <div class="radio-group__labels">
                            <span
                              class="radio-group__label radio-group__label--left"
                              >Dårlig</span
                            ><span class="radio-group__label" /><span
                              class="radio-group__label radio-group__label--right"
                              >Topp</span
                            >
                          </div>
                          <div class="radio-group radio-group--1-10">
                            {#each { length: 10 } as _, index}
                              <Radio
                                bind:group={olympicTraining}
                                value={index + 1}
                                label="Olympisk gjennomføring"
                              />
                            {/each}
                          </div>
                        </div>
                      </div>
                    {/if}
                  </div>
                  {#if false}
                    <fieldset class="form-section">
                      <h3>
                        <button
                          on:click={toggleRestituon}
                          type="button"
                          class="button-text button-text--chevron-down {showRestituon
                            ? 'is-toggled'
                            : ''}">RESTITUTIONSTILTAK</button
                        >
                      </h3>
                      <div
                        class={showRestituon ? "" : "radio-group--default-hide"}
                      >
                        <div>
                          <label
                            class="checkbox"
                            for="GymnasticsWomen.RestitutionDrink"
                            ><input
                              bind:checked={drinkDuringTraining}
                              type="checkbox"
                              class="checkbox__input-hidden"
                              id="GymnasticsWomen.RestitutionDrink"
                              name="GymnasticsWomen.RestitutionDrink"
                              value="GymnasticsWomen.RestitutionDrink"
                            /><span class="checkbox__input-custom" /><span
                              class="checkbox__label">Drikke under trening</span
                            ></label
                          ><label
                            class="checkbox"
                            for="GymnasticsWomen.RestitutionNutrition"
                            ><input
                              bind:checked={energiConsumptionDuringTraining}
                              type="checkbox"
                              class="checkbox__input-hidden"
                              id="GymnasticsWomen.RestitutionNutrition"
                              name="GymnasticsWomen.RestitutionNutrition"
                              value="GymnasticsWomen.RestitutionNutrition"
                            /><span class="checkbox__input-custom" /><span
                              class="checkbox__label"
                              >Energiinntak under trening</span
                            ></label
                          ><label
                            class="checkbox"
                            for="GymnasticsWomen.RestitutionNutritionStraight"
                            ><input
                              bind:checked={energiConsumptionAfterTraining}
                              type="checkbox"
                              class="checkbox__input-hidden"
                              id="GymnasticsWomen.RestitutionNutritionStraight"
                              name="GymnasticsWomen.RestitutionNutritionStraight"
                              value="GymnasticsWomen.RestitutionNutritionStraight"
                            /><span class="checkbox__input-custom" /><span
                              class="checkbox__label"
                              >Energiinntak rett etter trening (&lt; 30 min)</span
                            ></label
                          ><label
                            class="checkbox"
                            for="GymnasticsWomen.RestitutionRestSleep"
                            ><input
                              bind:checked={restSleep}
                              type="checkbox"
                              class="checkbox__input-hidden"
                              id="GymnasticsWomen.RestitutionRestSleep"
                              name="GymnasticsWomen.RestitutionRestSleep"
                              value="GymnasticsWomen.RestitutionRestSleep"
                            /><span class="checkbox__input-custom" /><span
                              class="checkbox__label"
                              >Hvile/søvn rett etter trening</span
                            ></label
                          ><label
                            class="checkbox"
                            for="GymnasticsWomen.RestitutionMassageTreatment"
                            ><input
                              bind:checked={massage}
                              type="checkbox"
                              class="checkbox__input-hidden"
                              id="GymnasticsWomen.RestitutionMassageTreatment"
                              name="GymnasticsWomen.RestitutionMassageTreatment"
                              value="GymnasticsWomen.RestitutionMassageTreatment"
                            /><span class="checkbox__input-custom" /><span
                              class="checkbox__label"
                              >Massasje/fysikalske tiltak etter trening</span
                            ></label
                          >
                        </div>
                      </div>
                    </fieldset>
                  {/if}
                </div>
                <fieldset class="form-section" id="activity-comments">
                  <h3>{$_("sessions.form.comment")}</h3>
                  <ul class="list-comments" />
                  <label class="input" for="comment-activity"
                    ><span class="input__label"
                      >{$_("sessions.form.newComment")}</span
                    ><textarea
                      rows="5"
                      type="text"
                      inputmode="text"
                      name="comment-activity"
                      id="comment-activity"
                      class="input__text"
                      bind:value={comments}
                    /></label
                  >
                  {#if false}
                    <label class="checkbox" for="comment-notification-activity"
                      ><input
                        type="checkbox"
                        class="checkbox__input-hidden"
                        id="comment-notification-activity"
                        name="comment-notification-activity"
                        value="on"
                      /><span class="checkbox__input-custom" /><span
                        class="checkbox__label">Varsle trener</span
                      ></label
                    >
                  {/if}
                </fieldset>
                <fieldset class="form-section form-section--submit">
                  <p class="warning">
                    {$_("sessions.form.warning")}
                  </p>
                  <div class="layout-buttons layout-buttons--left-right">
                    <button
                      on:click={close}
                      type="button"
                      class="button-text button-text--cancel"
                      >{$_("generic.buttons.cancel")}</button
                    >
                    <button
                      on:click={save}
                      type="button"
                      class="button button--icon button--icon-check"
                      >{$_("sessions.form.submit")}</button
                    >
                  </div>
                </fieldset>
              </form>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
{/if}
